module.exports = __webpack_public_path__ + "img/smartdraw_button.902450c0.jpg";